import React from "react";

import { templates } from "@reactivated";

import { TrackOrderDetails } from "../apps/orders/TrackOrderDetails";

export const Template = (
    props: templates.TrackOrderDetailsTemplate,
): React.ReactNode => {
    if (!props.unified_order) {
        return null;
    }
    return (
        <TrackOrderDetails
            order={props.unified_order}
            config={props.config}
            war_link={props.war_link}
        />
    );
};
